export const sizeBtn = {
  xLarge: "h-12 text-base leading-6 px-4",
  large: "h-10 text-sm leading-5 px-3",
  medium: "h-5 text-xs leading-4 px-2",
  small: "h-16 text-xs leading-4 px-1",
};
export const iconPositionClass = {
  left: "flex-row",
  right: "flex-row-reverse",
};
